// src/pages/CreateUser.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ClipLoader } from "react-spinners";
import axios from "axios";
import { apiURL } from "../config/config";

const CreateUser = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    nickname: "",
    username: "",
    password: "",
    level: 1,
    company: "Neon",
    position: "",
    flow: null,
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const normalizedValue =
      name === "username" ? value.replace(/\s/g, "") : value;

    setFormData((prev) => ({
      ...prev,
      [name]: name === "level" ? parseInt(value, 10) : normalizedValue,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        ...formData,
        username: formData.username.replace(/\s/g, ""),
      };
      const response = await axios.post(`${apiURL}auth/register`, payload);
      const userId = response.data?.users?.[0]?._id;

      toast.success("สร้างผู้ใช้สำเร็จ");
      navigate(userId ? `/edit-user/${userId}` : "/users");
    } catch (error) {
      console.error("Register error:", error);
      toast.error("ไม่สามารถสร้างผู้ใช้ได้");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="
        min-h-screen flex justify-center items-start pt-16
        bg-gray-100 dark:bg-gray-950 transition-colors
      "
    >
      <div
        className="
          w-full max-w-xl p-6 rounded-lg shadow-lg relative
          bg-white dark:bg-gray-900
          border border-gray-200 dark:border-gray-700
          text-gray-900 dark:text-gray-100
        "
      >
        {loading && (
          <div
            className="
              absolute inset-0 z-10 flex justify-center items-center
              bg-white/70 dark:bg-gray-800/70
            "
          >
            <ClipLoader size={60} color="#6366F1" />
          </div>
        )}

        <h2 className="text-2xl font-bold mb-6 dark:text-yellow-300">
          เพิ่มผู้ใช้ใหม่
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {[
            { label: "ชื่อจริง", name: "firstName" },
            { label: "นามสกุล", name: "lastName" },
            { label: "ชื่อเล่น", name: "nickname" },
            { label: "Username (Email)", name: "username" },
            { label: "Password", name: "password", type: "password" },
            { label: "ตำแหน่ง (Position)", name: "position" },
          ].map(({ label, name, type = "text" }) => (
            <div key={name}>
              <label className="font-semibold dark:text-gray-200">{label}</label>
              <input
                type={type}
                name={name}
                value={formData[name] ?? ""}
                onChange={handleChange}
                inputMode={name === "username" ? "email" : undefined}
                autoComplete={name === "username" ? "email" : undefined}
                required={["firstName", "lastName", "username", "password"].includes(
                  name
                )}
                className="
                  w-full p-2 rounded border
                  bg-gray-50 dark:bg-gray-800
                  border-gray-300 dark:border-gray-700
                  text-gray-900 dark:text-gray-100
                  focus:ring-2 focus:ring-indigo-400 dark:focus:ring-yellow-400
                "
              />
            </div>
          ))}

          <div>
            <label className="font-semibold dark:text-gray-200">
              บริษัท (Company)
            </label>
            <select
              name="company"
              value={formData.company}
              onChange={handleChange}
              className="
                w-full p-2 rounded border
                bg-gray-50 dark:bg-gray-800
                border-gray-300 dark:border-gray-700
                text-gray-900 dark:text-gray-100
              "
            >
              <option value="Neon">Neon</option>
              <option value="Optx">Optx</option>
            </select>
          </div>

          <div>
            <label className="font-semibold dark:text-gray-200">
              ลำดับความสำคัญ (Level)
            </label>
            <select
              name="level"
              value={formData.level}
              onChange={handleChange}
              className="
                w-full p-2 rounded border
                bg-gray-50 dark:bg-gray-800
                border-gray-300 dark:border-gray-700
                text-gray-900 dark:text-gray-100
              "
            >
              {[1, 2, 3, 4, 5].map((lvl) => (
                <option key={lvl} value={lvl}>
                  {lvl}
                </option>
              ))}
            </select>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="
              w-full py-2 rounded text-white font-semibold
              bg-green-600 hover:bg-green-700
              dark:bg-green-700 dark:hover:bg-green-800
              transition-colors
            "
          >
            {loading ? "กำลังบันทึก..." : "สร้างผู้ใช้"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateUser;
